export default __webpack_public_path__ + "static/media/filter.a4749856.svg";